import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images, includedItems } from "../../data/content";
export function Introducing() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-193" data-mp="jqqc5i0itrt4">
      <div className="mx-auto max-w-6xl lg:grid lg:grid-cols-2 lg:items-center lg:gap-12" data-id="element-194" data-mp="jodruy7aj5cw">
        <div className="text-center lg:text-left" data-id="element-195" data-mp="oos1gkojind1">
          <p className="font-display text-base font-semibold uppercase tracking-wide text-sun" data-id="element-196" data-mp="3n7ypppo7u5i1">Introducing</p>
          <h2 className="mt-2 font-display text-[2.4rem] font-bold leading-[1.05] sm:text-6xl" data-id="element-197" data-mp="3s7bnh5gmkwze">The Pediatric OT Planning System™</h2>
          <p className="mt-4 text-lg font-bold text-white/85 sm:text-xl" data-id="element-198" data-mp="yo1cnak95qs">
            A Practical Planning, Documentation & Progress-Tracking Toolkit for Pediatric Occupational Therapists
          </p>
        </div>
        <img src={images.mockup} alt="All six volumes and five bonus packs" className="-mx-4 mt-8 w-[calc(100%+2rem)] max-w-none rounded-none bg-white lg:mx-0 lg:mt-0 lg:w-full lg:rounded-[2rem]" data-id="element-199" data-mp="34ev3gpdbuuxg" />
      </div>

      <div className="mx-auto mt-12 max-w-3xl space-y-4 text-lg leading-relaxed text-white/85" data-id="element-200" data-mp="xd5cpqpf8pmo">
        <p data-id="element-201" data-mp="skc8r51s1lbn">
          I organized this collection around six areas of professional organization: session planning, goal organization, caseload management, progress tracking, documentation, and follow-up.
        </p>
        <p data-id="element-202" data-mp="jlig1prkhf3d">
          The idea is straightforward: bring useful planning resources together so you can choose the templates that fit your workflow instead of repeatedly creating documents from scratch.
        </p>
        <p data-id="element-203" data-mp="9mt9uu919j2y">You can use the collection as a starting point, adapt the worksheets to your setting, and incorporate the resources that make sense for your professional responsibilities.</p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl rounded-[2rem] bg-white p-6 text-navy sm:p-8" data-id="element-204" data-mp="23zrhf63cm1ml">
        <p className="font-display text-xl font-bold uppercase tracking-wide" data-id="element-205" data-mp="1zzgyytyddiqu">Here’s what’s included:</p>
        <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-206" data-mp="3tgd8h3vkvs3v">
          {includedItems.map(item => <li key={item} className="flex items-start gap-3 text-lg font-bold leading-snug" data-id="element-207" data-mp="24bj7b90znmr">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-teal text-white" data-id="element-208" data-mp="3kikq1quk84c9">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-209" data-mp="3og8qf9f0upbj" />
              </span>
              {item}
            </li>)}
        </ul>
        <p className="mt-6 border-t border-navy/10 pt-5 text-center font-display text-lg font-semibold text-teal-dark" data-id="element-210" data-mp="l0l3igaitaf7">
          One organized collection. Multiple practical planning tools.
        </p>
      </div>

      <CtaButton label="Get the complete system for $27" className="mt-10" data-id="element-211" data-mp="bzdaacmv2zrz" />
    </section>;
}